var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.52,
    height: 19.54,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25748 19.2574C0.57498 18.5749 0.57498 17.4724 1.25748 16.7899L8.04748 9.9999L1.25748 3.2099C0.574979 2.5274 0.574979 1.4249 1.25748 0.742397C1.93998 0.0598983 3.04248 0.0598982 3.72498 0.742397L11.7575 8.7749C12.44 9.4574 12.44 10.5599 11.7575 11.2424L3.72498 19.2749C3.05998 19.9399 1.93998 19.9399 1.25748 19.2574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardForwardArrow);
export default __webpack_public_path__ + "static/media/dashboard-forward-arrow.952af643e7fe042733d3e9eb61c5a03f.svg";
export { ForwardRef as ReactComponent };